<template>
    <v-container v-if="tag">
        <v-row>
            <v-col cols="12" order-md="2">
                <div class="d-flex justify-center justify-md-end">
                    <action-buttons
                        :state="editState"
                        :permissions="userPermission"
                        :disabled="isLoading"
                        @save="handleSave"
                        @cancel="handleCancel"
                        @close="handleClose"
                        :is-dirty="isDirty"
                        class="d-flex justify-end"
                    />
                </div>
            </v-col>
        </v-row>
        <v-form ref="form" v-model="valid">
            <v-row>
                <v-col cols="12" md="4">
                    <v-text-field v-model="tag.text" label="Tag Text" @change="isDirty = true" />
                </v-col>
                <v-col cols="12" md="8">
                    <v-select
                        :items="entityTypes"
                        label="Entity Types"
                        v-model="tag.entityTypes"
                        multiple
                        chips
                        @change="isDirty = true"
                    ></v-select>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>
<script>
import api from '@/api'
import { mapState } from 'vuex'
import navGuardConfirmMixin from '../../mixins/navGuardConfirmMixin'
import editorMixin from '../../mixins/editorMixin'
export default {
    name: 'TagEditor',
    mixins: [navGuardConfirmMixin, editorMixin],
    data() {
        return {
            valid: true,
            tag: null,
            entityTypes: [
                { text: 'Plot', value: 1 },
                { text: 'Encounter', value: 2 },
                { text: 'Monster', value: 3 },
                { text: 'Rumour', value: 4 },
                { text: 'Lammie', value: 5 },
                { text: 'ResearchRequest', value: 6 },
                { text: 'RitualCircle', value: 7 },
                { text: 'Event', value: 8 },
                { text: 'EventSlots', value: 9 },
                { text: 'ResearchPeriod', value: 10 },
                { text: 'Team', value: 11 },
                { text: 'User', value: 12 },
                { text: 'Page', value: 13 },
            ],
        }
    },
    props: {
        id: {
            type: [String, Number],
            required: false,
            default: undefined,
        },
    },
    computed: {
        ...mapState(['user']),
        userPermission() {
            if (this.user && this.user.isAdmin) {
                return this.user.editEvents.all
            } else {
                return []
            }
        },
        editState() {
            return this.id ? 'Edit' : 'Create'
        },
    },
    mounted() {
        if (this.id) {
            this.getTag()
        } else {
            this.newTag()
        }
    },
    methods: {
        getTag() {
            this.isLoading = true
            api.get(`tags/${this.id}`)
                .then(res => {
                    this.tag = res
                })
                .finally(() => {
                    this.isDirty = false
                    this.isLoading = false
                })
        },
        newTag() {
            this.tag = {}
            this.isDirty = false
        },
        handleSave(isClose) {
            if (!this.validate()) return
            this.isSaving = true
            let data = Object.assign({}, this.tag)
            if (this.id) {
                api.put(`tags/${this.id}`, data)
                    .then(() => {
                        this.showSnackbar('success', `Tag Updated`)
                        this.isDirty = false
                        if (isClose) {
                            this.handleClose()
                        }
                    })
                    .finally(() => {
                        this.isSaving = false
                    })
            } else {
                api.post(`tags`, data)
                    .then(() => {
                        this.showSnackbar('success', `Tag Created`)
                        this.isDirty = false
                        if (isClose) {
                            this.handleClose()
                        }
                    })
                    .finally(() => {
                        this.isSaving = false
                    })
            }
        },
        handleCancel() {
            this.$router.push({ name: 'tagsList' })
        },
        handleClose() {
            this.$router.push({ name: 'tagsList' })
        },
        validate() {
            return true
        },
    },
}
</script>
